import RulesFooter from './RulesFooter';

export default RulesFooter;
